export default __webpack_public_path__ + "static/media/t-turnover.9c321cdf.webp";